import React from 'react';

import styled from '@emotion/styled';

export const Superscript = styled.sup`
  font-size: 8px;
`;

export const FooterDisclaimer = () => (
  <React.Fragment>
    <div>
      <Superscript>▵</Superscript>Online reviews as of 12/03/2021
    </div>
    <div>
      *Among 856 customers subscribed to Curology for 3+ months. Self-reported.
    </div>
  </React.Fragment>
);
